var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "divide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.291,
    height: 42.798,
    viewBox: "0 0 43.291 42.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_428",
    "data-name": "Line 428",
    d: "M39.324,1.936H-.032A1.968,1.968,0,0,1-2-.032,1.968,1.968,0,0,1-.032-2H39.324A1.968,1.968,0,0,1,41.291-.032,1.968,1.968,0,0,1,39.324,1.936Z",
    transform: "translate(2 21.186)",
    fill: "#3b3952"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(16.234)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(0 0)",
    fill: "#050020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(0 34.927)",
    fill: "#050020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide);
export default __webpack_public_path__ + "static/media/divide.730552e30d9a4d2b74e796c18ed3e0d8.svg";
export { ForwardRef as ReactComponent };